// panel.ts
import { Action } from "@ngrx/store";
import { MilesAndMoreInitState } from "../models/miles-and-more";

export const UPDATE_USER_LOGIN_STATUS = "UPDATE_USER_LOGIN_STATUS";
export const UPDATE_USER_MILES = "UPDATE_USER_MILES";
export const UPDATE_SELECTED_MILES = "UPDATE_SELECTED_MILES";
export const UPDATE_REDEEM_STATUS = "UPDATE_REDEEM_STATUS";
export const UPDATE_CHECOUT_STATUS = "UPDATE_CHECOUT_STATUS";
export const REFRESH_MILES_REEDUCER = 'REFRESH_MILES_REEDUCER';
export const MILES_PAYMENT_STATUS = "MILES_PAYMENT_STATUS";
export const RESET_MILES = 'RESET_MILES';
export const UPDATE_MILES_BALANCE = "UPDATE_MILES_BALANCE";
export const CAN_PAY_WITH_MILES = "CAN_PAY_WITH_MILES";
export const MILES_DISCOUNT = "MILES_DISCOUNT";
export const PRICE_WHEN_REDEEMED = "PRICE_WHEN_REDEEMED";
export const MILES_ERROR_TYPE = "MILES_ERROR_TYPE";
export const UPDATE_MAX_MILES_RANGE = "UPDATE_MAX_MILES_RANGE";
export const ADD_MILES_SERVICE_CARD = "ADD_MILES_SERVICE_CARD";

export interface ActionWithPayloadInterface extends Action {
  payload: any;
}


const initialState: MilesAndMoreInitState = {
  isUserLoggedIn: false,
  miles: null,
  selectedMiles: 0,
  milesRedeemed: false,
  payByMilesResponse: null,
  milesVerified: null,
  canPayWithMiles: true,
  milesDiscount: 0,
  priceWhenRedeemed: 0,
  errorType: null,
  milesServiceCard: ''
};

export function milesAndMoreReducer(
  state = initialState,
  action: ActionWithPayloadInterface
) {
  switch (action.type) {
    case UPDATE_USER_LOGIN_STATUS:
      return Object.assign({}, state, { isUserLoggedIn: action.payload });

    case UPDATE_USER_MILES:
      return Object.assign({}, state, { miles: action.payload });

    case UPDATE_MILES_BALANCE:
      return Object.assign({}, state, { miles: Object.assign({}, state.miles, { milesBalance: action.payload }) });

    case UPDATE_MAX_MILES_RANGE:
      return Object.assign({}, state, { miles: Object.assign({}, state.miles, { maximumMiles: action.payload }) });

    case UPDATE_SELECTED_MILES:
      return Object.assign({}, state, { selectedMiles: action.payload });

    case UPDATE_REDEEM_STATUS:
      return Object.assign({}, state, { milesRedeemed: action.payload });

    case UPDATE_CHECOUT_STATUS:
      return Object.assign({}, state, { payByMilesResponse: action.payload });

    case MILES_PAYMENT_STATUS:
      return Object.assign({}, state, { milesVerified: action.payload });

    case CAN_PAY_WITH_MILES:
      return Object.assign({}, state, { canPayWithMiles: action.payload });

    case MILES_DISCOUNT:
      return Object.assign({}, state, { milesDiscount: action.payload });

    case PRICE_WHEN_REDEEMED:
      return Object.assign({}, state, { priceWhenRedeemed: action.payload });

    case MILES_ERROR_TYPE:
      return Object.assign({}, state, { errorType: action.payload });

    case ADD_MILES_SERVICE_CARD:
      return Object.assign({}, state, { milesServiceCard: action.payload });

    case REFRESH_MILES_REEDUCER:
      state = Object.assign({}, action.payload);
      return state;

    case RESET_MILES:
      state = Object.assign({}, initialState);
      return state;

    default:
      return state;
  }
}
